'use strict';//Indicating browser should run only in java script mode

var EMRCommonSelectDiagnosisMasterList = angular.module('EMR.CommonSelectDiagnosisMasterList', [])